import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Menu, X, Moon, Sun } from "lucide-react";
import { OrbitWordmark } from "@/components/Brand";
import { useTheme } from "@/context/ThemeContext";
import { Button } from "@/components/ui/button";

const LINKS = [
  { label: "How ORBIT Works", href: "#how-it-works" },
  { label: "Why ORBIT", href: "#why-orbit" },
  { label: "About MYTHIVA", href: "#about" },
];

export function PublicNav() {
  const { theme, toggle } = useTheme();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 border-b border-border/70 bg-background/80 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-8 lg:px-12">
        <Link to="/" data-testid="nav-home-link"><OrbitWordmark subtle size={26} /></Link>

        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} className="text-sm font-medium text-muted-foreground transition-colors hover:text-foreground">
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Button variant="ghost" size="icon" onClick={toggle} aria-label="Toggle theme" data-testid="public-theme-toggle">
            {theme === "dark" ? <Sun className="h-[18px] w-[18px]" /> : <Moon className="h-[18px] w-[18px]" />}
          </Button>
          <Button variant="ghost" className="hidden sm:inline-flex" onClick={() => navigate("/login")} data-testid="nav-signin-btn">
            Sign in
          </Button>
          <Button className="hidden bg-accent text-accent-foreground hover:bg-accent/90 sm:inline-flex" onClick={() => navigate("/register")} data-testid="nav-start-btn">
            Start Assessment
          </Button>
          <button className="rounded-md p-2 text-muted-foreground hover:bg-muted md:hidden" onClick={() => setOpen((o) => !o)} aria-label="Menu">
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-border bg-background px-4 py-4 md:hidden">
          <div className="flex flex-col gap-3">
            {LINKS.map((l) => (
              <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="text-sm font-medium text-muted-foreground">
                {l.label}
              </a>
            ))}
            <div className="flex gap-2 pt-2">
              <Button variant="outline" className="flex-1" onClick={() => navigate("/login")}>Sign in</Button>
              <Button className="flex-1 bg-accent text-accent-foreground" onClick={() => navigate("/register")}>Start</Button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
